import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { contactInfo } from '../data/mock';

const CTASection = () => {
  const navigate = useNavigate();
  const [showPhone, setShowPhone] = useState(false);

  const goToContact = () => {
    navigate('/contact');
    window.scrollTo(0, 0);
  };

  return (
    <section className="bg-gradient-to-r from-blue-600 to-blue-700 py-16 lg:py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
          Prêt à démarrer votre projet ?
        </h2>
        <p className="text-lg text-blue-100 mb-8 max-w-2xl mx-auto">
          Obtenez un devis gratuit et personnalisé pour vos besoins en installation et support informatique
        </p>
        
        <div className="flex flex-wrap justify-center gap-4">
          <Button 
            className="bg-white text-blue-600 hover:bg-blue-50 font-semibold px-6 py-3 rounded-full flex items-center gap-2 h-auto transition-all duration-200 shadow-lg"
            onClick={goToContact}
          >
            <FileText className="w-5 h-5" />
            Demander un devis gratuit
          </Button>
          
          {showPhone ? (
            <span 
              className="border-2 border-white bg-white text-blue-600 font-semibold px-6 py-3 rounded-full flex items-center gap-2 h-auto select-all cursor-default"
            >
              <Phone className="w-5 h-5" />
              {contactInfo.phone}
            </span>
          ) : (
            <Button 
              variant="outline"
              className="border-2 border-white text-white hover:bg-white/10 font-semibold px-6 py-3 rounded-full flex items-center gap-2 h-auto transition-all duration-200"
              onClick={() => setShowPhone(true)}
            >
              <Phone className="w-5 h-5" />
              Appelez-nous
            </Button>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
